import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';

import { basename } from './settings';
import { store } from './store/store';

import Loader from './components/UI/Loader/Loader';
import IndexWrapper from './components/utilComponents/IndexWrapper/IndexWrapper';
// import WagmiWrapper from './components/utilComponents/WagmiWrapper/WagmiWrapper';
import Background from './components/UI/Background/Background';
import WagmiHandler from './components/utilComponents/WagmiHandler/WagmiHandler';

import './scss/index.scss';

const App = lazy(() => import('./App'));
const PingPage = lazy(() => import('./components/pages/PingPage/PingPage'));
const ShowStrikesPage = lazy(() => import('./components/pages/ShowStrikesPage/ShowStrikesPage'));
// const ColorModeHandler = lazy(() => import('./components/utilComponents/ColorModeHandler/ColorModeHandler'));
const EscapeHandler = lazy(() => import('./components/utilComponents/EscapeHandler/EscapeHandler'));
const Header = lazy(() => import('./components/UI/Header/Header'));
const Footer = lazy(() => import('./components/UI/Footer/Footer'));
// const WagmiHandler = lazy(() => import('./components/utilComponents/WagmiHandler/WagmiHandler'));
const ModalsController = lazy(() => import('./components/modals/ModalsController/ModalsController'));
const MainUpdater = lazy(() => import('./components/utilComponents/MainUpdater/MainUpdater'));
const UIPage = lazy(() => import('./components/pages/UIPage/UIpage'));
const DocsPage = lazy(() => import('./components/pages/DocsPage/DocsPage'));


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
root.render(
	<IndexWrapper>
		<Provider store={store}>
			<Router basename={basename}>
				<Suspense fallback={<Loader transparent fullPage/>}>
					<Switch>
						<Route exact path='/ping'>
							<PingPage/>
						</Route>
						<Route exact path='/UI'>
							<UIPage/>
						</Route>
						<Route exact path='/strikes/show'>
							{/* <ColorModeHandler/> */}
							<Header/>
							<ShowStrikesPage/>
						</Route>
						<Route exact path='/docs'>
							<Background/>
							{/* <Header/> */}
							<DocsPage/>
						</Route>
						<Route>
							<Background/>
							<WagmiHandler/>
							<EscapeHandler/>
							<MainUpdater/>
							<div className='ContentContainer'>
								<Header/>
								<div className='ContentContainer-main'>
									<App/>
								</div>
								<Footer/>
							</div>
							<ModalsController />
						</Route>
					</Switch>
				</Suspense>
			</Router>
		</Provider>
	</IndexWrapper>
);